import { render, staticRenderFns } from "./receipt_reprint.vue?vue&type=template&id=0896747c&scoped=true&"
import script from "./receipt_reprint.vue?vue&type=script&lang=js&"
export * from "./receipt_reprint.vue?vue&type=script&lang=js&"
import style0 from "./receipt_reprint.vue?vue&type=style&index=0&id=0896747c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0896747c",
  null
  
)

export default component.exports